import React from 'react';

import { getIsLoggedIn, isVerificationAccount } from '@app/redux/auth/auth.selectors';
import { useAppSelector } from '@app/redux/hooks';
import RoutePaths from '@app/routes/paths';
import useGenerateRoutePath from '@app/routes/paths/useGenerateRoutePath';

import { AnimatedRedirect } from '@components/transition/route';

function OnlyAuthorizedRoute({ children }: { children: JSX.Element }) {
	const { isVerified } = useAppSelector(isVerificationAccount);
	const generateRoutePath = useGenerateRoutePath();
	const isLoggedIn = useAppSelector(getIsLoggedIn);

	if (!isLoggedIn) return <AnimatedRedirect to={generateRoutePath(RoutePaths.AUTH.LOGIN)} />;
	else if (!isVerified) return <AnimatedRedirect to={generateRoutePath(RoutePaths.VERIFICATION.ACCOUNT)} />;
	else return children;
}

export default OnlyAuthorizedRoute;
